"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
interface PylonArticle {
  id: string;
  identifier: string;
  title: string;
  url: string;
}
export function usePylonArticles(enabled) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["pylon-articles"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== enabled) {
    t1 = {
      queryKey: t0,
      queryFn: _temp,
      enabled,
      staleTime: 604800000,
      retry: false,
      refetchOnMount: true
    };
    $[1] = enabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return useQuery(t1);
}
async function _temp() {
  const res = await fetch("/api/pylon/articles");
  if (!res.ok) {
    throw new Error("Failed to fetch articles");
  }
  return await res.json();
}